















































































































import Vue from 'vue';
import { Program, Traverser, GetDataExpression, Type, ReferenceData } from 'expangine-runtime';
import { sendNotification } from './app/Notify';
import { TypeSettings } from './runtime/types/TypeVisuals';
import { LiveRuntime } from 'expangine-runtime-live';
import { System } from './app/SystemEvents';
import Registry from './runtime';



export default Vue.extend({
    props: {
        projectName: String,
        programName: String,
    },
    data: () => ({
       registry: Registry,
       loading: true, 
       invalid: true,
       program: null as Program | null,
       tab: null,
       dataIndex: 0,
       output: null as any,
       loadings: 0,
    }),
    computed: {
        multiplePrograms(): boolean {
            return this.registry.defs.programs.values.length > 1;
        },
        currentProgram: {
            get(): string {
                return this.program ? this.program.name : '';
            },
            set(name: string) {
                this.program = this.registry.defs.getProgram(name);
            },
        },
        referencedData(): ReferenceData[] {
            if (!this.program) {
                return [];
            }

            const names: Record<string, ReferenceData> = Object.create(null);

            this.program.expression.traverse(new Traverser((expr) => {
                if (expr instanceof GetDataExpression) {
                    const data = this.registry.defs.getData(expr.name);
                    if (data) {
                        names[expr.name] = data;
                    }
                }
            }));

            return Object.values(names);
        },
        settings(): TypeSettings | null {
            if (!this.program) {
                return null;
            }

            if (this.registry.getTypeSettingsValidFor(this.program.dataType, this.program.meta)) {
                return this.program.meta;
            }
            
            return this.program.meta = this.registry.getTypeSettings(this.program.dataType);
        },
        currentData(): any {
            return this.program ? this.program.datasets[this.dataIndex].data : null;
        },
        outputType(): Type {
            return this.registry.defs.describe(this.output);
        },
        outputSettings(): TypeSettings {
            return this.registry.getTypeSettings(this.outputType);
        },
    },
    async mounted() {
        System.off('loading').on('loading', this.handleLoading);

        try {
            const { defs } = Registry;
            const project = await (await fetch(`shares/${this.projectName}`)).json();
            
            defs.sync(project);

            const program = defs.getProgram(this.programName);

            if (program) {
                this.program = program;
                this.invalid = false;
            }
        } catch (e) {
            sendNotification({ message: 'There was an error loading the shared project, please contact The Creator.' });
        }

        this.loading = false;
    },
    methods: {
        updateOutput() 
        {
            if (this.program) {
                this.output = LiveRuntime.run(this.program.expression, this.currentData);
            }
        },
        getDataSettings(data: ReferenceData) 
        {
            return this.registry.getTypeSettings(data.dataType);
        },
        edit() 
        {
            this.$router.push({
                path: '/', query: { share: this.projectName },
            });
        },
        async handleLoading(eventType: 'loading', loadable: () => Promise<any>)
        {
            this.loadable(loadable);
        },
        async loadable<R = any>(callback: () => R | Promise<R>): Promise<R | undefined>
        {
            let result: R | undefined;
            this.loadings++;

            try
            {
                await this.$nextTick();

                result = await callback();
            }
            catch (e)
            {
                sendNotification({ message : 'There was an unexpected error: ' + e });

                window.console.log('error in loadable', e);
            }

            this.loadings--;

            return result;
        },
    },
});
